import {
  PosMultiSelect,
  PosMultiSelectProps,
} from 'src/core/POS/PosMultiSelect';
import { ContentId } from 'src/utils/constants/contentId';
import { TICKET_STATUS_TO_CID } from 'src/utils/constants/contentIdMaps';

import { TicketStatus } from './TicketStatus.types';

export type TicketStatusMultiSelectorProps = Omit<
  PosMultiSelectProps,
  'valueOptionsContent'
> & {
  valueOptionsContent?: Record<TicketStatus, string>;
};

export const TicketStatusMultiSelector = ({
  placeholderText = ContentId.All,
  valueOptionsContent,
  ...rest
}: TicketStatusMultiSelectorProps) => {
  return (
    <PosMultiSelect
      style={{ width: '100%' }}
      {...rest}
      placeholderText={placeholderText}
      valueOptionsContent={valueOptionsContent ?? TICKET_STATUS_TO_CID}
      sortMode="none"
    />
  );
};
